export default {
  toolbar_lang: {
    languages: {
      english: "English",
      thai: "Thai",
    },
    uat: "UAT",
    profile: "Profile",
    role: "Seller",
    logout: "Logout",
    listmenu: {
      dashboard: "Dashboard",
      account: "Factor",
      buyer: "Buyer",
      import: "Import",
      disbursement: "Disbursement",
      status: "Status",
      rejecthistory: "Reject History",
      report: "Report",
      invoiceReport: "Report ",
      reportCancel: "Report Cancel",
      reportReject: "Report Rejection",
      importOnline: "Import Online",
      importExcel: "Import Excel",
      importEtax: "Import Etax",
      requestorg: "Request to business",
      approve: "Approve",
      gotoetax: "e-Tax Invoice & e-Receipt",
      billingrpt: "Billing RPT",
      consider: "Consider Preliminaly Loan",
      payment: "Payment",
      notifyCount: "Invoice Overdue",
      otherservice: "Service",
    },
    listappbarmenu: {
      admin: "Admin setting",
      surway: "Satisfaction survey",
    },
    transactionList: "Transaction menu",
    otherList: "Other",
  },
  admintoolbar_lang: {
    languages: {
      english: "English",
      thai: "Thai",
    },
    uat: "UAT",
    profile: "Profile",
    role: "Seller",
    logout: "Logout",
    listmenu: {
      requestorg: "Request to org",
      settingca: "Register CA",
      rolePermission: "Role Permission",
      roleSetting: "Role Setting",
      log: "Log",
      notification: "Notification",
      update: "Update document status",
    },
    backtouser: "Return to the main page",
    admin: "Admin (Seller)",
  },
  admin_update_lang: {
    title: "Update document status",
    close: "Close",
    open: "Open",
    p1: "The system will send the document status in the form",
    p2: "<url>/EfactoringLog/ConfirmStatus/<serller_taxid>/<sk_id received after sending invoices to the system efactoring>/<invoice_id>",
    p3: "Example",
    p4: "https://example-url.com/EfactoringLog/ConfirmStatus/0100037xxxxx/3e715454d-8898-4429-9efb-dddf2eebe220/INV-TEST0001",
  },
  admin_role_setting_lang: {
    title: "Role Setting",
    table: {
      pic: "Picture",
      name: "Name",
      oneid: "OneID",
      email: "email",
      typeEmployee: "Employee type",
      position: "Position",
      permission: "Permission",
      super: "Super Admin",
      itemsPerPage: "items per page",
    },
    dialog: {
      username: "Username",
      role: "Role",
      status: "Status",
      remove: "Remove",
    },
    admin: "Admin",
    user: "User",
    nodata: "No Data",
  },
  admin_log: {
    title: "Activity Log",
    filter: "Filter",
    labelSearch: "Find",
    table: {
      date: "Date",
      name: "User",
      type: "Type",
      activity: "Activity",
      itemsPerPage: "items per page",
    },
    startDate: "Date",
    toDate: "To",
    invoice: "Invoice",
    searchBtn: "Search",
    clearBtn: "Clear",
  },
  admin_role_permission_lang: {
    title: "Manage Permission",
    table: {
      name: "Permission name",
      count: "Count",
      action: "Action",
    },
    addBtn: "Add Permission",
  },
  add_role_lang: {
    title: "Create Role",
    cancelBtn: "Cancel",
    addBtn: "Add Role",
    roleDetail: "Role Detail",
    roleName: "Role name",
    permission: {
      view: "View",
      download: "Download",
      ced: "Create/Update/Delete",
      upload: "Upload",
      approve: "Approve",
    },
    page: {
      account: "Account",
      import: "Import",
      disbursement: "Disbursement",
      status: "Status",
      report: "Report",
    },
  },
  admin: {
    notificationtitle: "Notification Setting",
    notificationemail: "Get notified via E-mail",
    notificationchat: "Get notified via OneChat",
    settingdialogemail: "Set up to receive notifications via email.",
    settingdialogchat: "Set up to receive notifications via OneChat.",
    hq: "Head Office",
    branch: "Branch",
    branchno: "Branch number",
    sender: "Sender",
    recipient: "Recipient",
    recipientlist: "Recipient list",
    name: "Name",
  },
  profile_lang: {
    profileUserTitle: "User Detail (Seller)",
    profileBusiness: "Business Detail (Seller)",
    accountId: "Account ID.",
    username: "Username",
    nameTh: "Full Name (Thai)",
    nameEng: "Full Name (English)",
    email: "Email (One Platform)",
    businessId: "Business ID.",
    taxId: "Tax ID.",
    businessnameTh: "Business Name (Thai)",
    businessnameEng: "Business Name (English)",
  },
  account_lang: {
    accountTitle: "Account",
    enable: "Enable",
    disable: "Disable",
    headerTable: {
      contractId: "Contract ID",
      factorName: "Name",
      contactPerson: "Contact Person",
      contactTel: "Contact Tel",
      contractStatus: "Status",
    },
    listtotal: "list",
  },
  dashboard_lang: {
    dashboardTitle: "Dashboard",
    baht: " THB",
    amount: "Total Finance",
    transactions: "Invoice",
    nowithdrwl: "No credit withdrawal information",
    withdraw: "Withdraw no.",
    withdrawTitle: "Amount of loan withdrawal",
    invoiceStatus: "Invoice Status",
    paidStatus: "Reimbursement rate (%)",
    lastopendoc: "Recently opened documents",
    donutLabel: "Total", // ! เปลี่ยนภาษาแล้วมันไม่เปลี่ยนตามเพราะมันเป็นรูป
    headerTable: {
      issuedate: "Issue date",
      invoiceid: "Invoice ID",
      buyername: "Buyer Name",
      buyerid: "Buyer ID",
      amount: "Amount",
      duedate: "Due date",
      poref: "PO Ref",
    },
    search: "Search",
    nodata: "No Data",
  },
  importonline_lang: {
    title: "Import Attachment Online",
    detail: "Attachment detail",
    form: {
      type: "Type",
      ref: "Ref. invoice number",
      buyername: "Buyer Name",
      buyerid: "Buyer ID",
      invoiceid: "Attachment ID",
      issuedate: "Issue Date",
      duedate: "Due date",
      amount: "Amount",
      poref: "PO Ref",
      attachment: "Attachment",
      reason: "Reason for transaction",
      original: "Original value",
      correct: "Correct value",
      dif: "Difference (credit note value)",
    },
    label: {
      buyername: "Please enter buyer name",
      buyerid: "Please enter buyer id",
      invoiceid: "Please enter invoice id",
      issuedate: "Please enter issue date.",
      duedate: "Please enter due date.",
      amount: "0.00 (BAHT)",
      amount2: "Please enter amount",
      poref: "Please enter PO Ref",
      attachment: "Click to attach file",
      reason: "Please enter reason for transaction",
      original: "0.00 (BAHT)",
      correct: "0.00 (BAHT)",
      dif: "0.00 (BAHT)",
      diftext: "Please enter the difference",
    },
    table: {
      type: "Type",
      date: "Date",
      invoiceid: "Attachment ID",
      buyername: "Buyer Name",
      buyerid: "Buyer ID",
      amount: "Amount",
      issuedate: "Issue Date",
      duedate: "Due Date",
      poref: "PO Ref",
      invref: "Invoice Ref",
      attachment: "Attachment",
      edit: "Edit",
      remove: "Remove",
      more: "Action",
      reason: "Reason for transaction",
      original: "Original value",
      correct: "Correct value",
      dif: "Difference (credit note value)",
    },
  },
  importexcel_lang: {
    importExcelTitle: "Import invoices (Excel)",
    importFile: "File to import",
    remarkRequest: "** Only Excel (.xlsx) file are supported",
    statusImportTable: "Invoice import list status",
    importBtn: "Import",
    importBtnCredit: "Import",
    clearBtn: "Clear",
    FormExample: "Form example",
    downloadBtn: "Download Form",
    remark: "Remark",
    remarkText:
      "To import data by Excel, proceed to download the form. and use the specified format only.",
    importCount: " List",
    nodata: "No Data",
    headerTable: {
      invoiceId: "Invoice ID",
      docidt: "Doc ID",
      buyerTaxId: "Buyer ID",
      amount: "Amount",
      issueDate: "Issue date",
      dueDate: "Due date",
      status: "Status",
      message: "Detail",
    },
    // ! เปลี่ยนภาษาแล้วมันไม่เปลี่ยนตาม
    rules: {
      require: "Required File",
      wrongtype: "Wrong type",
    },
    textfield: {
      header:
        "You can add multiple documents by uploading an Excel file with the following steps:",
      header2:
        "You can add multiple buyer by uploading an Excel file with the following steps:",
      line1:
        "1. Prepare the Excel file in the format specified by the system. which can download the form An example can be found below.",
      line2: "Download Excel form",
      line3:
        "2. Select your prepared Excel file and click Next to check the data.",
      line4: "Drag the files you want to upload here",
      line5: "or",
      line6: "select files",
      line7: "from your computer",
    },
    process: "Processing",
    success: "Successfully",
    error: {
      title: "Error ",
      list: " list value ",
      baht: " Baht",
      from: " from ",
    },
  },
  dialogimportetax_lang: {
    importetaxTitle: "Import Doc (Etax)",
    importBtn: "Next",
    closeBtn: "Close",
    cancelBtn: "Cancel",
    disbursement: "Disbursement",
  },
  importetax_lang: {
    importetaxTitle: "Import Doc (Etax)",
    fileBtn: "Import PDF/XML",
    condition: "Document search conditions",
    searchBtn: "Search",
    clearBtn: "Clear",
    documentTypeItems: {
      all: "All",
      doc380: "Invoice",
      doc388: "Tax Invoice",
      docT02: "Invoice/Tax Invoice",
      docT03: "Receipt/Tax Invoice",
      docT04: "Delivery Note/Tax Invoice",
    },
    importBtn: "Import",
    searchForm: {
      docdatefrom: "Document Date",
      processdatefrom: "Process Date",
      todate: "To",
      sellerbranchId: "Seller Branch",
      buyername: "Buyer Name",
      buyerbranchId: "Buyer Branch",
      buyerTaxId: "Buyer ID",
      docform: "Invoice form",
      docto: "to",
      doctype: "Document Type",
    },
    totalcount: " List",
    nodata: "No Data",
    headerTable: {
      documenttype: "Document Type",
      sellerbranchId: "Seller Branch",
      documentId: "Invoice ID",
      documentDate: "Document Date",
      buyerId: "Buyer ID",
      buyerbranchId: "Buyer Branch",
      buyerName: "Buyer Name",
      amount: "Amount",
    },
  },
  report_lang: {
    reportTitle: "Report",
    reportCancelTitle: "Report Cancel",
    reportRejectTitle: "Report Reject",
    condition: "Document search conditions",
    searchForm: {
      buyerName: "Buyer Name",
      buyerId: "Buyer ID",
      invoiceId: "Invoice ID",
      lastupdateDate: "Last update",
      todate: "To Date",
      issueDate: "Issue date",
      duedate: "Due date",
      factorName: "Factor Name",
      lastCancel: "Issue date",
    },
    status: "Status",
    groupInvoice: "Group Invoice ID",
    clearBtn: "Clear",
    searchBtn: "Search",
    downloadBtn: "Download",
    counttotal: " List",
    viewstatus: "View Status Detail",
    headerTable: {
      groupId: "Document ID",
      debitgroupId: "Credit Note ID",
      lastupdate: "Last update",
      invoiceId: "Invoice ID",
      buyerName: "Buyer Name",
      buyerId: "Buyer ID",
      amount: "Amount",
      actual_amount: "Actual amount",
      purchaserate: "Purchase rate",
      issueDate: "Issue Date",
      dueDate: "Due Date",
      status: "Status",
      factorName: "Factor Name",
      lastCancel: "Cancel date",
      timeCancel: "Cancel time",
      remark: "Remark",
      sellerUpdate: "Seller update",
      lastReject: "Reject date",
      timeReject: "Reject date",
      sentDate: "Sent Date",
      postedDate: "Posted Date",
      cancelledDate: "Canceled Date",
      rejectedDate: "Rejected Date",
      paidDate: "Paid Date",
      indisputedDate: "Indisputed Date",
      financedDate: "Financed Date",
      reassign_date: "Re-assign Date",
      repayment_date: "Re-payment Date",
      checkAll: "Check all",
      selectTable: "Select Table",
      docDate: "Document Date",
      oldAmount: "Old amount",
      newAmount: "New amount",
      diffAmount: "Different amount",
      refInv: " Invoice reference ",
      remarkRef: "Remark reference",
      acceptedDate: "Accepted Date",
      rejectRemark: "Reject remark",
      creditNoteId: "Credit note ID",
      issueDatedebit: "Credit note Date",
    },
  },
  dialogViewStatusDetail_lang: {
    statusTitle: "Status Detail",
    sented: "Pending",
    post: "Verified and under consideration",
    approve: "Currently considering credit approval",
    finance: "Approve credit",
    complete: "Finish the process",
    paid: "Payment has been made.",
    indisputed: "Doubtful debts",
    waitindisputed: "Awaiting approval of doubtful debts",
    boterror: "Duplicate loan application data found",
    duplicate: "Registration invoice found",
    exists: "Duplicate loan application invoice found",
    expired: "Invoice overdue",
    closeBtn: "Close",
  },
  disbursement_lang: {
    disbursementTitle: "Disbursement",
    detailSort: "Issue Date",
    transferBtn: "Transfer",
    search: "Search",
    counttotal: " List",
    nodata: "No Data",
    moreOptions: {
      view: "View",
      upload: "Upload",
      download: "Download",
      edit: "Edit",
      delete: "Delete",
    },
    debitheaderTable: {
      issueDate: "Issue date",
      invoiceId: "Doc ID",
      buyerName: "Buyer Name",
      buyerId: "Buyer ID",
      dueDate: "Due date",
      old_amount: "Original value",
      new_amount: "Correct value",
      diff_amount: "Difference (credit note value)",
      attachment: "Doc",
      ref: "Ref. invoice number",
      reason: "Reason for transaction",
      option: "Option",
      no: "No.",
      invoice: "Invoice",
    },
    headerTable: {
      issueDate: "Issue date",
      invoiceId: "Doc ID",
      buyerName: "Buyer Name",
      buyerId: "Buyer ID",
      dueDate: "Due date",
      amount: "Amount",
      attachment: "Attachment",
      detail: "Detail",
      option: "Option",
    },
    completeInfo: "Complete Info",
    incompleteInfo: "Incomplete Info",
    filter: {
      condition: "Document search conditions",
      beginissue: "Issue date",
      to: "To",
      duedate: "Due date",
      invoiceid: "Inoive ID",
      buyerid: "Buyer ID",
      buyername: "Buyer Name",
    },
  },
  rejecthistory_lang: {
    counttotal: " List",
    rejecthistoryTitle: "Reject History",
    headerTable: {
      invoiceId: "Invoice ID",
      buyerId: "Buyer ID",
      buyerName: "Buyer Name",
      issueDate: "Issue date",
      amount: "Amount",
      dueDate: "Due date",
      status: "Status",
    },
  },
  dialogViewAttachment_lang: {
    viewTitle: "Invoice attachment list",
    counttotal: " List",
    nodata: "No Attachment",
  },
  dialogUploadAttachment_lang: {
    uploadTitle: "Upload Attachment",
    invoiceId: "Invoice ID",
    creditId: "Credit Note ID",
    labelText:
      "Drag and drop files here or <span class='filepond--label-action'>click to upload</span>",
    download: "Download",
    otherAttachment: "Attachment",
  },
  dialogDownloadAttachment_lang: {
    downloadTitle: "Download Invoice",
    remark: "Remark",
    text: "Can download e-Invoice only for items made on August 11, 2021 onwards.",
    download: "Download",
    closeBtn: "Close",
  },
  dialogUpdateAttachment_lang: {
    updateTitle: "Edit Invoice",
    updateTitleDebit: "Edit credit note details",
    closeBtn: "Close",
    updateBtn: "Update",
    form: {
      issueDate: "Issue date",
      dueDate: "Due date",
      buyerName: "Buyer Name",
      buyerId: "Buyer ID",
      invoiceId: "Invoice ID",
      amount: "Amount",
      poref: "PO Ref",
      status: "Status",
    },
    formDebit: {
      creditNoteId: "Doc Id",
      issueDate: "Issue date",
      invoiceId: "Ref Inv",
      buyerName: "Buyer Name",
      buyerId: "Buyer ID",
      remark: "remark",
      old_amount: "Old Value",
      new_amount: "Correct Value",
      diff_amount: "Diff (Credit Note Value)",
    },
  },
  dialogGroup_lang: {
    groupTitle: "Group Invoice",
    nodata: "No Data",
    factorName: "Factor",
    cancelBtn: "Cancel",
    closeBtn: "Close",
    submitBtn: "Submit",
    headerTable: {
      status: "Status",
      issueDate: "Issue date",
      invoiceId: "Invoice ID",
      buyerName: "Buyer Name",
      buyerId: "Buyer ID",
      dueDate: "Due date",
      amount: "Amount",
      purchaserate: "Purchase rate",
      poref: "PO Ref",
      delete: "Remove",
    },
    headerTableDebit: {
      status: "Status",
      issueDate: "Issue date",
      invoiceId: "Credit Note ID",
      buyerName: "Buyer Name",
      buyerId: "Buyer ID",
      old_amount: "Old Value",
      new_amount: "Correct Value",
      diff_amount: "Diff (Credit Note Value)",
      purchaserate: "Purchase rate",
      poref: "INV Ref",
      delete: "Remove",
    },
    totalcount: "Total count ",
    countText: "List",
    totalAmount: "Total amount ",
    baht: "THB",
  },
  statusGetListInGroup_lang: {
    statusTitle: "Check Status",
    search: "Search",
    counttotal: " List",
    nodata: "No Data",
    viewstatus: "View Status Detail",
    headerTable: {
      issueDate: "Issue date",
      invoiceId: "Invoice ID",
      buyerId: "Buyer ID",
      buyerName: "Buyer Name",
      amount: "Amount",
      actual_amount: "Actual amount",
      purchaserate: "Purchase rate",
      dueDate: "Due date",
      overDate: "Late",
      attachment: "Attachment",
      status: "Status",
      option: "Options",
      verify: "Verify",
      docDate: "Document Date",
      docId: "Document ID",
      oldAmount: "Old amount",
      newAmount: "New amount",
      diffAmount: "Different amount",
      ref: "Referent invoice",
      remark: "Remark",
      delete: "Delete",
    },
    attachment: "Attachement",
    overdue: "overdue",
    revoke: "Revoke",
    verifyBtn: "Verify",
    moreOptions: {
      add: "Increase/decrease debt",
      upload: "Upload Attachment",
      revoke: "Revoke",
      download: "Download",
    },
    dialog: {
      name: "Name",
      sign: "Signature",
      btn: "Close",
    },
  },
  status_lang: {
    statusTitle: "Check Status",
    filter: "Advanced Search",
    detailSort: "Issue Date",
    condition: "Document search conditions",
    searchForm: {
      buyerName: "Buyer Name",
      buyerId: "Buyer ID",
      invoiceId: "Invoice ID",
      lastupdate: "Last update",
      todate: "To date",
      issueDate: "Issue date",
      duedate: "Due date",
      status: "Status",
      groupId: "Group Invoice ID",
      amount: "Amount",
    },
    clearBtn: "Clear",
    searchBtn: "Search",
    counttotal: " List",
    nodata: "No Data",
    viewstatus: "View Status Detail",
    headerTable: {
      issueDatedebit: "Issue date",
      issueDate: "Issue date",
      docId: "Document ID",
      docIddebit: "Document ID",
      factorName: "Factor Name",
      transactions: "Transaction",
      amount: "Amount(THB)",
      purchaserate: "Purchase rate",
      actual_amount: "Actual amount",
      quantity: "Quantity",
      status: "Status",
      delete: "Remove",
      coversheet: "Sheet",
      download: "Download",
      importby: "Update By",
      more: "Action",
      invoiceDownload: "Invoices",
      attachmentDownload: "Attachment",
      buyerId: "Buyer Tax ID",
      BuyerName: "Buyer Name",
      oldAmount: "Old amount",
      realAmount: "Real amount",
      diffAmount: "diff Amount",
      refInv: "Ref invoice",
      remark: "Remark",
    },
    removeBtn: "Remove",
    filterBtn: "Filter",
    attachmentDownloadButton: {
      downloadInvoice: "Download invoice",
      downloadAttachment: "Download the attachment",
      downloadAllDocuments: "Download all documents",
    },
  },
  buyerDetail_lang: {
    buyerTitle: "Buyer Detail",
    search: "Search",
    addbuyer: "Add Contract",
    addwithexcel: "Import with Excel",
    cantadd: "Unable to add accounts because the contract is not activated",
    counttotal: " account",
    nodata: "No Data",
    headerTable: {
      customercode: "Customer ID",
      buyerId: "Buyer ID",
      BuyerName: "Buyer Name",
      email: "E-mail",
      address: "Address",
      amount: "Limit Transfer",
      amountfee: "Balance",
      pendingamount: "Pending Amount",
      amountexceed: "Amount Exceed",
      remark: "Remark",
      options: "Options",
    },
    errorlist: "Error List",
    dialogtitle: "Import buyer by excel",
  },
  editContractBuyer_lang: {
    contractTitle: "Edit Contract Buyer",
    subTitle: "Buyer Infomation",
    cancelBtn: "Cancel",
    submitBtn: "Save",
    // ! เปลี่ยนภาษาแล้วมันไม่เปลี่ยนตาม
    rules: {
      requireTax: "Please Input Buyer ID",
      requireBranch: "Please Input Buyer Branch ID",
      requireName: "Please Input Buyer Name",
      requireAddress: "Please Input Address",
    },
    editForm: {
      customercode: "Customer ID",
      buyerId: "Buyer ID",
      buyerName: "Buyer Name(Thai)",
      buyerNameEng: "Buyer Name(Eng)",
      buyerBranch: "Branch ID",
      email: "E-mail",
      address: "Address",
      remark: "Remark",
      customerTypeThai: "Agency(Thai)",
      customerTypeEng: "Agency(Eng)",
      title: "Buyer Detail",
      create: "Create Buyer",
      update: "Update Buyer",
      contactPerson: "Contact person",
      contactTel: "Contact tel.",
      contactMail: "Contact email",
      bizType: "Business Type",
      businessType: {
        business: "Business",
        citizen: "Citizen",
      },
      btnRevenue: "Search by Revenue Department",
      btnTaxID: "Search by taxID",
      textRevenue: "or",
      zipcode: "Zipcode",
      subdistrict: "Subdistrict",
      district: "District",
      province: "Province",
    },
    placeholder: "Coment here",
    agency: {
      gov: "Government agency",
      state: "State enterprise",
      partner: "Limited partnership",
      company: "Limited company",
      public: "Public company",
      single: "Single owner business",
      venture: "Joint venture",
      commercial: "Commercial registration",
      store: "Store",
      other: "Other",
    },
  },
  accountDetail_lang: {
    contract: "Contract",
    contractFactoring: "Factoring",
    contractPreFinance: "Pre-finance",
    status: "Contract status",
    accountTitle: "Account Detail",
    activate: "Activated",
    deactivated: "Deactivated",
    remark: "Remark",
    contractKeeper: "Contract Keeper",
    form: {
      factorname: "Factor Name",
      platformId: "Platform ID",
      contactPerson: "Contact Person",
      contractTel: "Contact Tel",
      contractId: "Contract ID",
      issueDate: "Date of contract",
      dueDate: "Due date (Factoring term)",
      day: " Day",
      amount: "Amount",
      interestrate: "Interest rate",
      peryear: "per year",
      fee: "Sales fee",
      value: "of value",
      entrancefee: "Entrance fee",
      baht: "THB",
      purchaserate: "Purchase rate",
      valuegood: "of value",
      branch: "Branch ID",
      codename: "Code",
    },
    buyerList: "Buyer list",
    buyerListBtn: "Show Buyer List",
    finance: "Financial statements",
    nostatement: "No Statement",
    list: " List",
    statement: "Statement",
    download: "Download",
    filter: "Filter",
    search: "Search",
    table: {
      customercode: "Customer Code",
      buyername: "Buyer Name",
      branch: "Branch",
      amount: "Amount limit",
      amountremain: "Amount used",
      buyertax: "Buyer Tax ID",
      contractId: "Contract ID",
      lastUpdate: "Last update",
      startDate: "Start Date",
      endDate: "End Date",
      action: "Action",
    },
  },
  addContractBuyer_lang: {
    addTitle: "Add Contract Buyer",
    subTitle: "Buyer Infomation",
    cancelBtn: "Cancel",
    submitBtn: "Submit",
    placeholder: "Coment here",
    addForm: {
      customercode: "Customer ID",
      buyerId: "Buyer ID",
      buyerName: "Buyer Name",
      buyerBranch: "Buyer Branch ID",
      email: "E-mail",
      address: "Address",
      remark: "Remark",
    },
    // ! เปลี่ยนภาษาแล้วมันไม่เปลี่ยนตาม
    rules: {
      requireTax: "Please Input Buyer ID",
      requireBranch: "Please Input Buyer Branch ID",
      requireName: "Please Input Buyer Name",
      requireAddress: "Please Input Address",
    },
  },
  managecad_lang: {
    headerTable: {
      name: "Name",
      taxid: "Seller ID",
      branch: "Branch",
      cad: "CAD",
      action: "Action",
    },
    actionMenu: {
      editcad: "Edit",
      remove: "Remove",
    },
    addBtn: "Add Seller",
  },
  increase_decrease_lang: {
    title: "Increase debt/Reduce debt",
    titleetax: "Increase debt/Reduce debt by E-Tax ",
    detail: "Detail",
    clearBtn: "Clear",
    submitBtn: "Submit",
    exceltitle: "Import debit/credit in Excel format",
    btn: {
      excel: "Import invoices by excel",
      etax: "Import invoices by e-tax",
    },
    form: {
      invoiceid: "Invoice ID",
      buyername: "Buyer Name",
      issuedate: "Issue date",
      duedate: "Due date",
      doctype: "Document Type",
      docdate: "Document date",
      docid: "Document ID",
      poref: "PO Ref",
      remark: "Remark",
      attachment: "attach document",
      oldvalue: "original value",
      newvalue: "new value",
      diff: "difference",
    },
    doctype: {
      debit: "Debit Note",
      credit: "Credit Note",
      tradedebit: "Trade Debit Note",
      tradecredit: "Trade Credit Note",
      all: "All",
    },
    header: {
      doctype: "Document Type",
      invoiceid: "Document ID",
      oldvalue: "Old amount",
      newvalue: "New amount",
      diff: "Different",
      remark: "Remark",
      attachment: "Attachment",
    },
    filter: {
      title: "Filter Invoices by E-Tax",
      docform: "Document ID from",
      docto: "To",
      docdate: "Document Date",
    },
    newamountmore: "The new value must be greater",
    newamountless: "The new value must be less",
  },
  approve_lang: {
    title: "Approve List",
    headerTable: {
      factorname: "Factor Name",
      factortaxid: "Factor Tax ID",
      invoiceid: "Invoice ID",
      buyername: "Buyer Name",
      buyerid: "Buyer Tax ID",
      detail: "Detail",
      waitingapprove: "Items",
      action: "Action",
      issuedate: "Issue Date",
      amount: "Amount",
    },
    approveMenu: {
      disbursement: "Disbursement",
      status: "Status",
      buyer: "Buyer",
      waittodelete: "Remove Group",
    },
  },
  dialogApprove_lang: {
    headerTable: {
      invoiceid: "Invoice ID",
      buyerid: "Buyer Tax ID",
      buyername: "Buyer Name",
      amount: "Amount",
      issuedate: "Issue Date",
      duedate: "Due Date",
      status: "Status",
      action: "Action",
    },
    closeBtn: "Close",
    title: "Detail",
  },
  importetaxfile_lang: {
    selecttype: "Select type for upload",
    listinvoice: "List Invoice",
    header: {
      loading: "Process",
      document: "Document",
      pdf: "PDF",
      xml: "XML",
      status: "Status",
      action: "Action",
      remove: "Remove",
    },
    textfield: {
      header:
        "You can add multiple invoices by uploading an Excel file with the following steps:",
      line1:
        "1. Prepare the Excel file in the format specified by the system. which can download the form An example can be found below.",
      line2: "Download Excel form",
      line3:
        "2. Select your prepared Excel file and click Next to check the data.",
      line4: "Drag the files you want to upload here",
      line5: "or",
      line6: "select files",
      line7: "from your computer",
    },
    status: {
      ready: "Ready to upload",
      notready: "Not ready to upload",
      finish: "uploaded successfully",
    },
    confirm: "Confirm document",
    label: "Confirm delivery of documents that have not been certs.",
    dialog: {
      title: "Import E-Invoice",
      progress: "in progress ",
      from: " of ",
      list: " list",
      success: " list successfully",
    },
  },
  swal_lang: {
    error: "Failed to execute",
    sucess: "Successfully",
    fail: "Unable to process",
    submitBtn: "Submit",
    cancelBtn: "Cancel",
    confirmBuyer: "Confirm the creation of a buyer ?",
    updateBuyer: "Confirm the update of a buyer ?",
    createSucess: "Create buyer success",
    updateSucess: "Update buyer success",
    notfoundbuyer: "Not found buyer",
    confirmImport: "Confirm invoice import ?",
    confirmImportAt: "Confirm to add attachment  ?",
    nofilewrongtype: "No file or wrong file type",
    pleseinputdata: "Please complete the information.",
    pleseinputdata2: "Please complete the information or check the data.",
    removeInvoice: "Confirm remove invoice ?",
    removeInvoice2: "Confirm remove invoice ?",
    removeInvoice3: "Confirm remove invoice ?",
    removeInvoice4: "Confirm remove credit note ?",
    removeDebit: "Confirm remove credit note ?",
    confirmRemoveAttachment: "Confirm remove attachment ?",
    confirmRemoveInvoice: "Confirm remove invoice?",
    canclePosted: "Confirm request to cancel POSTED status ?",
    canclecancel: "Confirm to cancel CANCEL status ?",
    updateInvoice: "Confirm to update invoice ?",
    updateCdn: "Confirm to update credit note ?",
    confirmimportitem: "Confirm to import ",
    confirmimportitemcdn: "Confirm to import ",
    confirmimportitem2: " list ?",
    nogroupreject: "Group reject operation is not currently supported.",
    nogroupapprove: "Group approve operation is not currently supported.",
    updatenotification: "Confirm notification status change",
    enterbranch: "Please enter the branch number to complete 5 digits.",
    repeatuser: "Can't add recipient because the recipient is already listed",
    confirmupload: "Confirm file upload",
    filemax: "Only PDF files no more than 50 MB",
    deft: "Increase/decrease debt",
    endupload: " ?",
    onlyexcel: "Only Excel (.xlsx) files are supported.",
    removeinvoicesuccess: "Successfully deleted the invoice.",
    removeCDNsuccess: "Successfully deleted the Credit note.",
    updatesuccess: "Successfully edited",
    importsuccess: "Successfully imported invoices",
    importsuccesscdn: "Successfully imported credit note",
    onlypdfxml: "Only files (.xlsx .xls .doc .docx .pdf) are supported.",
    updatedeft: "Confirm the new valuation?",
    removedeft: "Confirm to remove ",
    addbuyersuccess: "Add buyer successfully",
    updatebuyersuccess: "Update buyer successfully",
    someerror: "Wrong information",
    editinvoice: "Edit invoice ",
    editcdn: "Edit credit note ",
    removeInvoicePermission:
      "Unable to delete data imported from the e-tax Invoice & e-reciept system.",
    importFileInvoiceFail:
      "Unable to attach invoice file Because the file format is incorrect.",
    importFileAttachmentFail:
      "Unable to attach file Because the file format is incorrect.",
    importFileInvoiceFailcdn:
      "Unable to attach credit note file Because the file format is incorrect.",
    importFileAttachmentFailcdn:
      "Unable to attach file Because the file format is incorrect.",
  },
  table: {
    nodata: "No Data",
    itemsPerPage: "items per page",
    loading: "Loading",
  },
  btn: {
    search: "Search",
    clear: "Clear",
    close: "Close",
    back: "Back",
    importinvoice: "Import",
    importcdn: "Import",
    import: "Import",
    add: "Add",
    edit: "Update",
    cancel: "Cancel",
    addbuyer: "Add Buyer",
    save: "Save",
    remove: "Remove",
    open: "Open",
    upload: "Upload",
    filter: "Filter",
    download: "Download",
    importbyexcel: "Import by Excel",
    create: "Create",
    downloadAll: "Download All",
    editCredit: "Save edit data",
  },
  rules: {
    taxid: "Tax ID must be 5 digits or 13 digits",
    thai: "Cannot use vowels(TH) or spaces at the beginning of sentences",
    poref: 'Please enter PO ref or if there is no information, fill in "-".',
    enteremail:
      'Please enter email or if there is no information, fill in "-". ',
    enterdate: "Please enter date",
    onlypdf: "***Only supports pdf files and 50 MB.",
    onlypdfxls: "***Only supports xlsx xls pdf files and 50 MB.",
    pnlypdfinvoic:
      "*Supports only PDF files, size not exceeding 10 MB, 1 file.",
    pnlypdfother:
      "*Only PDF files are supported, size not exceeding 10 MB per file, maximum 3 files.",
    enteraddress: "Please enter address",
    enteragency: "Please enter agency",
    enterbuyername: "Please enter buyer name",
    name_en: "Only English text is allowed",
    mail: "Invalid format Please fill in the example as sam@sam.com, me@me.com, test@test.com.",
    mail2:
      "Invalid format Please fill in the example as sam@gmail.com, me@outlook.co.th",
    selectcustomertype: "Please select the type of agency.",
  },
  label: {
    branch: "Branch ID",
  },
  etaxPage_lang: {
    title: "e-Tax Invoice & e-Receipt",
    suggestion1:
      "Users can bring electronic tax invoice information (e-Tax Invoice) can be submitted to the Revenue Department",
    suggestion2: "through the service of INET e-Tax Invoice & e-Receipt.",
    register: "Register",
    mark: "In case the customer already has an account with INET e-Tax Invoice, bring the Usercode and Access Key of INET e-Tax Invoice below.",
    verify: "Usercode and Access Key for e-Tax system verified.",
    confirm: "confirm",
    cancel: "cancel",
    remark1: "Remark :",
    remark2:
      "If you want to change your Usercode or Accesskey, you can come back and confirm the new Usercode and Accesskey on this page.",
  },
  page_invoice_manage: {
    title: "Update invoice status",
    title2: "Invoice over due",
    customer: "Customer",
    case: " List",
    btnFilters: "Filters",
    search: "Search",
    btnDisburment: "Transfer form",
    btnUpdateStatus: "Update status invoice",
    btnHistory: "Transaction history",
    textUpdate: "Update status invoice",
    show: "Click check status",
    menuUpdate: {
      menu1: "Update status to Financed",
      menu2: "Update status to Paid",
      menu3: "Request Indisputed",
      menu4: "Update status to Indisputed",
      menu5: "Update status to Rejected",
    },
    menuManage: {
      menu1: "Increase/Decrease",
      menu2: "Download invoice",
      menu3: "Edit Purchase rate",
    },
    filters: {
      title: "Filter conditions",
      buyerName: "Buyer name",
      p_buyerName: "Choose buyer name",
      invoiceId: "Invoice group number",
      p_invoiceId: "Please specify the invoice group number.",
      docId: "Invoice number",
      p_docId: "Please specify the invoice number",
      startdate: "Start date",
      issuedate: "Issue date",
      duedate: "Due date",
      to: "To",
      status: "Status",
      allStatus: "All status",
      amount: "Amount",
      bath: "Bath",
      btnClear: "Clear",
      btnSearch: "Search",
    },
    headerTable: {
      startdate: "Start date",
      groupId: "Group ID",
      invoiceId: "Invoice ID",
      buyerName: "Buyer name",
      transaction: "Transaction",
      amount: "Amount(Bath)",
      actual_amount: "Actual amount",
      purchaseRate: "Purchase rate",
      status: "Status",
      statusInvoice: "Status invoice",
      confirm: "Confirmed",
      manage: "Manage",
      file: "Cover",
      download: "Download Invoice",
      duedate: "Due Date",
    },
    dialogHeader: {
      menu1: "Action",
      menu2: "Last date seller",
      menu3: "Seller update by",
      menu4: "Last date facter",
      menu5: "Factor update by",
    },
  },
  page_account: {
    title: "Customer account",
    create_btn: "Create account",
    case: "List",
    search: "Search",
    no_data: "No data",
    showing: "Items per page",
    id: "Customer ID",
    name: "Customer name",
    tax_id: "Tax ID",
    contract_id: "Contract ID",
    amount: "Amount",
    total: "Amount free",
    status: "Status",
    all: "All",
    swl_title: "No permission",
    swl_text: "You do not have access to create a customer account",
    swl_sc: "",
    swl_er: "Failed",
  },
  page_admin: {
    log_title: "Log",
    log_search: "Search log",
    log_clear: "Clear",
    log_sort: "Sort",
    log_date: "Date and Time",
    log_user: "User",
    log_type: "Type",
    log_act: "Activity",
    log_invoice: "Invoice Id",
    log_date_from: "Start date",
    log_date_to: "to",
    count: "Item per page",
    from: "from",
    no_data: "No data",
    per_title: "Role setting",
    per_pic: "Picture",
    per_name: "Name",
    per_one: "OneID",
    per_type: "Employee type",
    per_pos: "Position",
    per_per: "Permission",
    per_super: "Super Admin",
    role_title: "Manage roles",
    role_name: "Role name",
    role_title2: "Create role",
    role_btn: "Add role",
    role_number: "Number of role",
    role_mange: "Manage",
    addrole_cancel: "Cancel",
    addrole_addbtn: "Add role",
    addrole_editbtn: "Edit role",
    addrole_sub: "Role info",
    addrole_name: "Role name",
    addrole_v: "View only",
    addrole_d: "Download",
    addrole_ced: "Create/edit/delete",
    addrole_a: "Approve",
    add_swl1: "Confirm to creact role ?",
    add_swl2: "Confirm",
    add_swl3: "Cancel",
    add_swl4: "Success",
    add_swl5: "Create role sucess",
    add_swl6: "Fail",
    add_swl7: "Please enter role name",
    add_swl8: "Confirm to cancel create role ?",
    edit_swl1: "Confirm to edit role  ?",
    edit_swl2: "Confirm to cancel edit role  ?",
    edit_swl3: "Edit role sucess",
    rca_title: "Register RCA",
    rca_menu: "Setting RCA",
    list: {
      list1: "Buyer/Seller",
      list2: "Create group invoice",
      list3: "Create tranfer letter",
      list4: "Import invoice",
      list5: "Disbursement",
      list6: "Update status Finance/Reject",
      list7: "Update status Paid/Indisputed",
      list8: "Report",
    },
  },
  page_disbursement: {
    title: "Transfer of claims (invoices)",
    detailSort: "Issue Date",
    customer: "Customer",
    click: "Click to view document status",
    disabled: `You don't have a license to use it. Please contact the administrator.`,
    list: "List",
    search: "Search",
    noData: "No information",
    issue_date: "Execution date",
    business_name: "Customer name",
    transaction: "Number of claims",
    amount: "Total amount (Baht)",
    status: "Status",
    purchase_rate: "Purchase rate",
    managedata: "Manage data",
    option_name: {
      0: "Register",
      1: "Cancel the invoice",
      2: "Details",
    },
  },
  page_report: {
    report: "Report",
    search_conditions: "Search conditions",
    customer: "Customer",
    name: "Trade account receivable name",
    invoice_number: "Invoice number",
    invoice_group_number: "Invoice group number",
    execution_date: "Execution date",
    to: "to",
    document_date: "Document date",
    due_date: "Due date",
    status: "Status",
    clear: "Clear",
    search: "Search",
    download_report: "Download report",
    list: "List",
    no_data: "No information",
    click: "Click to view document status",
    disabled: `You don't have a license to use it. Please contact the administrator.`,
    data_table: {
      last_update: "Execution date",
      doc_id: "Invoice group number",
      invoice_id: "Invoice number",
      buyer_name: "Trade account receivable name",
      amount: "Amount",
      purchase_rate: "Purchase rate",
      issue_date: "Document date",
      due_date: "Due date",
      status: "Status",
    },
  },
  page_consider: {
    title: "Consider Preliminary Loan",
    btnCheck: "Check status ",
    tab1: "Information",
    tab2: "Sent Invoice",
    subtt1: "Information",
    subtt2: "Contact",
    sellername: "Business name",
    branch: "Branch",
    type: "Business type",
    r_type: "Please enter business type",
    regisCap: "Registered Capital",
    r_regisCap: "Please enter Registered Capital",
    regisDate: "Registered Date",
    r_regisDate: "Plaese enter Registered Date",
    aveBill: "Average Bill",
    r_aveBill: "enter Average Bill",
    monthIn: "Monthly Income",
    r_monthIn: "enter Monthly Income",
    partner: "Parnter business",
    r_partner: "enter Parnter business",
    interestedCredit: "Interested Credit",
    r_interestedCredit: "Please enter Interested Credit",
    r_contactPerson: "enter contact person",
    position: "Position",
    r_contactTel: "enter contact tel",
    btnSave: "save",
    swalSuccess: "Save success",
    swalErr: "Fail",
    swalErrText: "Please enter form",
    btnSent: "Import",
  },
  credit: {
    creditId: "Document ID",
    creditIdLabel: "Please enter Document ID",
  },
};
//! this.$t('swal_lang.error'),
//* this.$t('swal_lang.sucess'),
//? this.$t('swal_lang.submitBtn'),
//todo this.$t('swal_lang.cancelBtn'),

// {{ $t('addContractBuyer_lang.addTitle') }}
// {{ $t('addContractBuyer_lang.rules.requireTax') }}
// {{ $t("addContractBuyer_lang.headerTable." + header.text) }}
